import { render, staticRenderFns } from "./ReportingInfo.vue?vue&type=template&id=24a075e6&"
import script from "./ReportingInfo.vue?vue&type=script&lang=ts&"
export * from "./ReportingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReportingInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports